const AUTO_NUMBER_LETTERS = 'авекмнорстух';

export const Masks = {
  PHONE: [
    '+',
    '7',
    ' ',
    '(',
    /[1-9]|\*/,
    /\d|\*/,
    /\d|\*/,
    ')',
    ' ',
    /\d|\*/,
    /\d|\*/,
    /\d|\*/,
    '-',
    /\d|\*/,
    /\d|\*/,
    '-',
    /\d|\*/,
    /\d|\*/,
  ],
  DATE: [/\d/, /\d/, '.', /[0-1]/, /\d/, '.', /[1-2]/, /\d/, /\d/, /\d/],
  MONTH: [/[0-1]/, /\d/, '.', /[1-2]/, /\d/, /\d/, /\d/],
  PASSPORT: [/\d/, /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/, /\d/, /\d/],
  UNIT_CODE: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/],
  FOUR_DIGITS: [/\d/, /\d/, /\d/, /\d/],
  INN: [/\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d?/, /\d?/],
  SNILS: [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, ' ', /\d/, /\d/],
  AUTO_NUMBER: [
    new RegExp(`[${AUTO_NUMBER_LETTERS}]`, 'i'),
    ' ',
    /\d/,
    /\d/,
    /\d/,
    ' ',
    new RegExp(`[${AUTO_NUMBER_LETTERS}]`, 'i'),
    new RegExp(`[${AUTO_NUMBER_LETTERS}]`, 'i'),
    ' ',
    /\d/,
    /\d/,
    /\d?/,
  ],
};

export const MaskPlaceholders = {
  PHONE: '+7 (___) ___-__-__',
  DATE: '__.__.____',
  MONTH: '__.____',
  PASSPORT: '____ ______',
  UNIT_CODE: '___-___',
  SNILS: '___-___-___-__',
  AUTO_NUMBER: '_ ___ __ ___',
};
